import TrackingDefinitionsEdit from './TrackingDefinitionsEdit';
import blankRAViews from '../../components/BlankRAViews';

export default {
  ...blankRAViews,
  edit: TrackingDefinitionsEdit,
};
